import { AppContext } from '../../../context';
import EmailCard from '../../../components/EmailCard';
import React, { useContext } from 'react';
import Wrapper from '../../../components/Wrapper';

const SuperdayExpiredPage: React.FC = () => {
    const { meetIntro, translate } = useContext(AppContext);

    const BACKGROUND_STYLES = {
        backgroundImage: `url("${meetIntro?.data?.meetBackgroundUrl}")`,
    };

    const logo = meetIntro?.data?.organization?.logoUrl;
    const backgroundImage = meetIntro?.data?.meetBackgroundUrlList[3] ?? meetIntro?.data?.meetBackgroundUrlList[0];

    return (
        <Wrapper loading={false} backgroundImage={backgroundImage} logo={logo}>
            {meetIntro?.data ? (
                <div className="container" style={BACKGROUND_STYLES}>
                    <EmailCard
                        meetIntro={meetIntro.data}
                        cardTextMessage={translate('expired:interviewHasExpired')}
                        isError
                    />
                </div>
            ) : (
                <div>{translate('general:loading')}</div>
            )}
        </Wrapper>
    );
};

export default SuperdayExpiredPage;
